import { useState, useEffect } from 'react';
import { Route, Switch, HashRouter as Router } from 'react-router-dom';
import { WhenJWebReady, JWebPromise } from '@jarvis/jweb-core';
import { ProgressIndicator } from '@veneer/core';
import { CookiesProvider } from 'react-cookie';
import HomePage from './pages/home';
import DesignerPage from './pages/designer';
import CartPage from './pages/cart';
import CheckoutPage from './pages/checkout';
import ExitPage from './pages/exit';
import AddToCartPage from './pages/addToCart';
import ListProjectsPage from './pages/listProject';
import OrdersPage from './pages/orders';
import PSFCallbacksCheckoutPage from './pages/psf/callbacks/checkout';
import ModalError, { ModalErrorDetail } from './components/Modals/Error';
import { ScreenInfo } from './jarvis/dataCollection';
import './App.css';
import UploadPage from './pages/upload';
import { LocalStorageHelper } from './helpers/localStorage';

const App = () => {
  const [startApp, setStartApp] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorDetail, setErrorDetail] = useState<ModalErrorDetail>();

  const screenInfo: ScreenInfo = {
    name: 'AppBase',
    activity: 'AppPhotobook-v01',
  };

  useEffect(() => {
    WhenJWebReady.then((res: JWebPromise) => {
      const device = res.JWeb.getPlatform();
      console.log('Detected device:', device);
      LocalStorageHelper.setDevice(device ?? 'android');
      if (device == 'web') {
        setErrorDetail({
          context: 'Designer opened in web browser',
          errorMessage: 'Sorry, but this application needs to run on a mobile device.',
        });
        setHasError(true);
      }
      res.JWeb.Plugins?.MCDesigner?.requestPermissions();
      setStartApp(true);
    });
  }, []);

  if (hasError) {
    return <ModalError state={hasError} detail={errorDetail as ModalErrorDetail} screenInfo={screenInfo} />;
  } else {
    return startApp ? (
      <CookiesProvider>
        <Router>
          <Route
            render={() => (
              <Switch>
                <Route exact path="/" component={HomePage} />
                <Route path="/designer/photoupload" component={UploadPage} />
                <Route path="/designer" component={DesignerPage} />
                <Route path="/addToCart" component={AddToCartPage} />
                <Route path="/cart" component={CartPage} />
                <Route path="/checkout" component={CheckoutPage} />
                <Route path="/exit" component={ExitPage} />
                <Route path="/projects" component={ListProjectsPage} />
                <Route path="/orders" component={OrdersPage} />
                <Route path="/psf/callback/checkout" component={PSFCallbacksCheckoutPage} />
              </Switch>
            )}
          />
        </Router>
      </CookiesProvider>
    ) : (
      <div className="spinner">
        <ProgressIndicator />
      </div>
    );
  }
};

export default App;
